(function() { module.exports = this["wp"]["blocks"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","blocks"]}
// module id = 0
// module chunks = 0 1 2